import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appValidateEmail]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidateEmailDirective, multi: true }]
})
export class ValidateEmailDirective implements Validator {

  constructor(
    private elementRef: ElementRef,
    private render: Renderer2
  ) { }

  validate(control: AbstractControl): ValidationErrors {
    return this.validateEmail(control.value);
  }

  @HostListener('input', ['$event.target'])
  onInput(element: any) {
    if(element.value) {
      this.elementRef.nativeElement.value = this.removeSpaces(element.value.toLowerCase());
    }
  }

  validateEmail(value?: string) {
    const expreg = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    const email = (value) ? value.toLowerCase().trim() : null;
    
    if (this.elementRef.nativeElement)
      if (value === null || value === '') {
        this.render.removeClass(this.elementRef.nativeElement, 'ng-valid');
        this.render.removeClass(this.elementRef.nativeElement, 'ng-invalid');
        return null;
      }
    if (expreg.test(email) === true) {
      this.render.addClass(this.elementRef.nativeElement, 'ng-valid');
      return null;
    } else {
      this.render.addClass(this.elementRef.nativeElement, 'ng-invalid');
      return { 'emailInvalid': { message: 'Correo electrónico inválido' } };
    }
  }

  removeSpaces(value: string) {
    return value.replace(" ", "");
  }

}